import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["autoFocus", "className", "date", "DateInputProps", "isMobileKeyboardViewOpen", "onDateChange", "onViewChange", "openTo", "orientation", "showToolbar", "toggleMobileKeyboardView", "ToolbarComponent", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useViews } from '../hooks/useViews';
import CalendarPicker from '../../../CalendarPicker';
import { KeyboardDateInput } from '../KeyboardDateInput';
import { useIsLandscape } from '../hooks/useIsLandscape';
import { WrapperVariantContext } from '../wrappers/WrapperVariantContext';
import PickerView from './PickerView';
export var MobileKeyboardInputView = styled('div')({
  padding: '16px 24px'
});
var PickerRoot = styled('div')(function (_ref) {
  var ownerState = _ref.ownerState;
  return _objectSpread({
    display: 'flex',
    flexDirection: 'column'
  }, ownerState.isLandscape && {
    flexDirection: 'row'
  });
});
var MobileKeyboardTextFieldProps = {
  fullWidth: true
};
var isDatePickerView = function isDatePickerView(view) {
  return view === 'year' || view === 'month' || view === 'day';
};
function Picker(props) {
  var autoFocus = props.autoFocus,
    className = props.className,
    date = props.date,
    DateInputProps = props.DateInputProps,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    onDateChange = props.onDateChange,
    onViewChange = props.onViewChange,
    openTo = props.openTo,
    orientation = props.orientation,
    showToolbar = props.showToolbar,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    _props$ToolbarCompone = props.ToolbarComponent,
    ToolbarComponent = _props$ToolbarCompone === void 0 ? function () {
      return null;
    } : _props$ToolbarCompone,
    toolbarFormat = props.toolbarFormat,
    toolbarPlaceholder = props.toolbarPlaceholder,
    toolbarTitle = props.toolbarTitle,
    views = props.views,
    other = _objectWithoutProperties(props, _excluded);
  var isLandscape = useIsLandscape(views, orientation);
  var wrapperVariant = React.useContext(WrapperVariantContext);
  var toShowToolbar = typeof showToolbar === 'undefined' ? wrapperVariant !== 'desktop' : showToolbar;
  var handleDateChange = React.useCallback(function (newDate, selectionState) {
    onDateChange(newDate, wrapperVariant, selectionState);
  }, [onDateChange, wrapperVariant]);
  var handleViewChange = React.useCallback(function (newView) {
    if (isMobileKeyboardViewOpen) {
      toggleMobileKeyboardView();
    }
    if (onViewChange) {
      onViewChange(newView);
    }
  }, [isMobileKeyboardViewOpen, onViewChange, toggleMobileKeyboardView]);
  var _useViews = useViews({
      view: undefined,
      views: views,
      openTo: openTo,
      onChange: handleDateChange,
      onViewChange: handleViewChange
    }),
    openView = _useViews.openView,
    nextView = _useViews.nextView,
    previousView = _useViews.previousView,
    setOpenView = _useViews.setOpenView,
    handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
  return /*#__PURE__*/React.createElement(PickerRoot, {
    ownerState: {
      isLandscape: isLandscape
    }
  }, toShowToolbar && /*#__PURE__*/React.createElement(ToolbarComponent, _extends({}, other, {
    views: views,
    isLandscape: isLandscape,
    date: date,
    onChange: handleDateChange,
    setOpenView: setOpenView,
    openView: openView,
    toolbarTitle: toolbarTitle,
    toolbarFormat: toolbarFormat,
    toolbarPlaceholder: toolbarPlaceholder,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView
  })), /*#__PURE__*/React.createElement(PickerView, null, isMobileKeyboardViewOpen ? /*#__PURE__*/React.createElement(MobileKeyboardInputView, null, /*#__PURE__*/React.createElement(KeyboardDateInput, _extends({}, DateInputProps, {
    ignoreInvalidInputs: true,
    disableOpenPicker: true,
    TextFieldProps: MobileKeyboardTextFieldProps
  }))) : isDatePickerView(openView) && /*#__PURE__*/React.createElement(CalendarPicker, _extends({
    autoFocus: autoFocus,
    date: date,
    onViewChange: setOpenView,
    onChange: handleChangeAndOpenNext,
    view: openView
    // Unclear why the predicate `isDatePickerView` does not imply the casted type
    ,
    views: views.filter(isDatePickerView)
  }, other))));
}
export default Picker;